import Button from "components/components/Button/Button";
import {
  ButtonsDiv,
  ContentContainer,
} from "components/components/Iris/AuthenticatedView/IrisDetailsPage/IrisDetails/IrisDeleteModal/style";
import { StyledCancelButton } from "components/components/Iris/AuthenticatedView/style";
import { LoadingSpinnerContainer } from "components/components/Iris/commonStyle";
import LoadingSpinner from "components/components/LoadingSpinner/LoadingSpinner";
import Modal, { ModalSize } from "components/components/Modal/Modal";
import WarningContainer from "components/components/WarningContainer/WarningContainer";
import {
  RequestStatus,
  useRequestWithDefaultErrorHandling,
} from "hooks/useRequest";
import React, { ReactNode } from "react";

type Props = {
  itemId: string | null;
  close: () => void;
  callDeleteEndpoint: (arg: string) => Promise<void>;
  itemLabel: string;
  description: ReactNode;
  fetchIrisDetails: () => void;
  title: ReactNode;
};

const IrisDeleteModal: React.FC<Props> = ({
  itemId,
  close,
  callDeleteEndpoint,
  itemLabel,
  description,
  fetchIrisDetails,
  title,
}) => {
  const isActive = itemId !== null;

  const { request: deleteRequest, status: deletionStatus } =
    useRequestWithDefaultErrorHandling(
      () => (itemId ? callDeleteEndpoint(itemId) : Promise.resolve()),
      `Sorry, something went wrong when deleting the ${itemLabel}.`
    );

  const handleDelete = async (): Promise<void> => {
    if (itemId) {
      await deleteRequest();
      close();
    }
  };

  return (
    <Modal size={ModalSize.medium} isActive={isActive} onClose={close}>
      <div aria-live="polite">
        {deletionStatus === RequestStatus.IN_PROGRESS ? (
          <LoadingSpinnerContainer>
            <LoadingSpinner isLoading />
            <p>Deleting {itemLabel}...</p>
          </LoadingSpinnerContainer>
        ) : (
          <ContentContainer>
            <h2>{title}</h2>
            <WarningContainer>{description}</WarningContainer>
            <hr />
            <ButtonsDiv>
              <StyledCancelButton
                ariaLabel="Cancel"
                buttonText="Cancel"
                onClick={close}
              />
              <Button
                ariaLabel={`Delete ${itemLabel}`}
                buttonText={`Delete ${itemLabel}`}
                onClick={(): void => {
                  handleDelete().then(fetchIrisDetails);
                }}
              />
            </ButtonsDiv>
          </ContentContainer>
        )}
      </div>
    </Modal>
  );
};

export default IrisDeleteModal;
